var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', [_c('b-card', [_c('h4', {
    staticClass: "card-title text-uppercase"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.app-settings.label.push-notifications')) + " ")]), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', [_c('span', [_vm._v(_vm._s(_vm.pushNotificationStatus) + " " + _vm._s(_vm.subscriptionStatus))])])], 1), _c('b-row', [_c('div', {
    staticClass: "col"
  }, [_vm.isSaving ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_c('b-btn', {
    staticClass: "mr-2",
    attrs: {
      "variant": "primary",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.register
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.subscribe')))])]), _c('b-btn', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.unregister
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.unsubscribe')))])])], 1)], 1)]), _c('b-row', [_c('b-col', {
    staticClass: "pt-4",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('video-embed', {
    attrs: {
      "type": "vimeo",
      "id": "850913466"
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }